export type GreetingKey = 'morning' | 'afternoon' | 'evening';

const MORNING_FROM = 5;
const AFTERNOON_FROM = 13;
const EVENING_FROM = 18;

/** Word of the greeting for the hour of the device (the user's own clock). */
export function greetingKey(hour: number): GreetingKey {
  if (hour >= MORNING_FROM && hour < AFTERNOON_FROM) return 'morning';
  if (hour >= AFTERNOON_FROM && hour < EVENING_FROM) return 'afternoon';
  return 'evening';
}
